__turbopack_context__.v({
  "badge": "FilterDropdown-module-scss-module__RWJ9XG__badge",
  "check": "FilterDropdown-module-scss-module__RWJ9XG__check",
  "chevron": "FilterDropdown-module-scss-module__RWJ9XG__chevron",
  "chevronOpen": "FilterDropdown-module-scss-module__RWJ9XG__chevronOpen",
  "dropdown": "FilterDropdown-module-scss-module__RWJ9XG__dropdown",
  "dropdownMulti": "FilterDropdown-module-scss-module__RWJ9XG__dropdownMulti",
  "menu": "FilterDropdown-module-scss-module__RWJ9XG__menu",
  "menuList": "FilterDropdown-module-scss-module__RWJ9XG__menuList",
  "menuMulti": "FilterDropdown-module-scss-module__RWJ9XG__menuMulti",
  "menuSearch": "FilterDropdown-module-scss-module__RWJ9XG__menuSearch",
  "noMatches": "FilterDropdown-module-scss-module__RWJ9XG__noMatches",
  "option": "FilterDropdown-module-scss-module__RWJ9XG__option",
  "optionLabel": "FilterDropdown-module-scss-module__RWJ9XG__optionLabel",
  "optionSelected": "FilterDropdown-module-scss-module__RWJ9XG__optionSelected",
  "trigger": "FilterDropdown-module-scss-module__RWJ9XG__trigger",
  "triggerActive": "FilterDropdown-module-scss-module__RWJ9XG__triggerActive",
  "triggerOpen": "FilterDropdown-module-scss-module__RWJ9XG__triggerOpen",
  "triggerText": "FilterDropdown-module-scss-module__RWJ9XG__triggerText",
});
